function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuOrder = function SvgMenuOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M887.1 126.2v814.4c0 11.9-6.6 22.8-17.1 28.4-10.5 5.6-23.3 4.8-33.1-1.9l-106.9-73-101.1 72.6c-12.1 8.7-28.7 7.9-39.9-1.9l-77-67.1-76.8 67.2c-11.2 9.9-27.8 10.7-39.9 1.9l-101.1-72.6-106.9 73c-9.9 6.7-22.6 7.5-33.1 1.9s-17.1-16.5-17.1-28.4V126.2c0-41.4 33.6-75 75-75h600.1c41.3 0 74.9 33.6 74.9 75zM340.5 458.4h342.9c17.7 0 32.1-14.4 32.1-32.1s-14.4-32.1-32.1-32.1H340.5c-17.7 0-32.1 14.4-32.1 32.1s14.4 32.1 32.1 32.1zm0-171.4h342.9c17.7 0 32.1-14.4 32.1-32.1s-14.4-32.1-32.1-32.1H340.5c-17.7 0-32.1 14.4-32.1 32.1s14.4 32.1 32.1 32.1zm0 342.9H512c17.7 0 32.1-14.4 32.1-32.1s-14.4-32.1-32.1-32.1H340.5c-17.7 0-32.1 14.4-32.1 32.1s14.4 32.1 32.1 32.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#666"
    }
  }));
};
export default SvgMenuOrder;